import React from "react";
import { CheckCircleIcon } from "staysure-component-library";

import ToggleBtnLabelWrapper from "@/app/shared-components/toggle-btn-wrapper/toggle-btn-label-wrapper";

import Styles from "./option-selection.module.css";
import { useCruiseContext } from "../../provider/cruise.provider";
import { CruiseOptionSelectionType } from "../../types/cruise.type";

function OptionSelection({
  options,
  onOptionSelect,
}: Readonly<CruiseOptionSelectionType>) {
  const { toggleWrapperRef } = useCruiseContext();
  return (
    <div
      ref={toggleWrapperRef}
      className="flex flex-row gap-spacing-xs md:mt-spacing-l mt-spacing-m btn-group-wrapper"
    >
      {options?.map(({ id, labelValue, isSelected }) => (
        <ToggleBtnLabelWrapper
          data-testid={`cruise-buttons-group-${id}`}
          id={`toggleButton-${id}`}
          key={`toggleButton-${id}`}
          label={labelValue}
          isToggleEnable={false}
          isDefaultActive={isSelected}
          isDisabled={false}
          btnType="button"
          onClick={() => {
            onOptionSelect(id, labelValue);
          }}
          isActiveRightIcon
          activeRightIcon={<CheckCircleIcon />}
          className={` active:bg-interactive-secondary-default active:text-dark-text-on-primary border-[1px]
                            bg-surface-neutral-option-1
                            border-interactive-secondary-default
                            text-text-on-primary w-full h-[56px] rounded-lg text-2xs text-left font-body-font leading-[24px] py-spacing-s px-spacing-s hover:px-[11px] flex flex-col justify-center self-start gap-grid-system-space-050 ${Styles.policy_togglebtn_wrapper} ${Styles.toggle_btn} hover:bg-interactive-action-hovered`}
        />
      ))}
    </div>
  );
}

export default OptionSelection;
